import { logoStyles } from '../../../styles/commonStyles';
import { getFontSize } from '../../../constants/fontSizes';

export const getHeaderStyles = (isSecondary = false) => {
  const linkColor = isSecondary ? 'secondary' : 'primary';
  const bookStayBgColor = isSecondary ? 'secondary' : 'primary';
  const bookStayTextColor = isSecondary ? 'primary' : 'secondary';
  const iconColor = isSecondary ? 'primary' : 'secondary';

  return {
    container: {
      justifyContent: 'center',
      display: 'flex',
      flex: 1,
      alignItems: 'center',
    },
    firstColumn: {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
      gap: 5,
    },
    logo: logoStyles,
    navLinksContainer: {
      display: 'flex',
      gap: {"2xl": "70px", xl: "50px", md: "30px"},
      marginLeft: {"2xl": "50px", xl: "30px", md: "10px"},
    },
    navLink: {
      textTransform: 'none',
      color: linkColor === 'secondary' ? 'secondary.main' : 'primary.main',
      fontFamily: 'Lato',
      '&:hover': {
        backgroundColor: 'transparent',
      },
      fontSize: getFontSize(18),
      fontWeight: 400
    },
    navLinkActive: {
      fontWeight: 700
    },
    secondColumn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: 2,
    },
    bookStayButton: {
      backgroundColor: bookStayBgColor === 'secondary' ? 'secondary.main' : 'primary.main',
      color: bookStayTextColor === 'primary' ? 'primary.main' : 'secondary.main',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: bookStayBgColor === 'secondary' ? 'secondary.dark' : 'primary.dark',
      },
      borderRadius: '52px',
      padding: '15px 20px',
      fontSize: getFontSize(18),
      fontWeight: 400
    },
    iconBox: {
      width: 35,
      height: 35,
      borderRadius: '50%',
      backgroundColor: iconColor === 'primary' ? 'primary.main' : 'secondary.main',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ml: 0.5,
    },
    icon: {
      fontSize: getFontSize(20),
      color: iconColor === 'primary' ? 'secondary.main' : 'primary.main',
    },
    secondaryButton: {
      textTransform: 'none',
      border: "none",
      color: 'primary.main',
      backgroundColor: 'secondary.main',
      '&:hover': {
        backgroundColor: 'transparent',
      },
      borderRadius: '52px',
      padding: '15px 40px',
      fontSize: getFontSize(18),
      fontWeight: 600
    },
    signInButton: {
      textTransform: 'none',
      borderColor: linkColor === 'secondary' ? 'secondary.main' : 'primary.main',
      color: linkColor === 'secondary' ? 'secondary.main' : 'primary.main',
      '&:hover': {
        borderColor: linkColor === 'secondary' ? 'secondary.dark' : 'primary.dark',
        backgroundColor: 'transparent',
      },
      borderRadius: '52px',
      padding: '15px 40px',
      fontSize: getFontSize(18),
      fontWeight: 600
    },
  };
};

